import { useState, useContext, createContext, useEffect } from "react";
import { createCleanerRequest } from "./requests.services";

export const RequestContext = createContext();


export const RequestContextProvider = ({ children }) => {

    const [isLoading, setIsLoading] = useState(false);

    const createNewRequest = async (requestData) => {
        try {
            setIsLoading(true);
            const response = await createCleanerRequest(requestData);
            const resp = await response.json();
            console.log(resp);
            return resp;
        } catch (error) {
            console.log({error});
        }finally{
            setIsLoading(false);
        }
    }


    return (
        <RequestContext.Provider
            value={{
                isLoading,
                createNewRequest
            }}
        >
            {children}
        </RequestContext.Provider>
    )
}

export const useRequestContext = () => useContext(RequestContext);

